import kendo from "@progress/kendo-ui";
import { downloadExcel } from "../../com/downloadExcel";
import { parseDate } from "../../com/dateUtil";

const url = "/alarm";

export const getAlertList = async (conn, dataState) => {
  const { take, skip, sort, startDtm, endDtm, eventType, userId, userTerm, rgnCode, dongCode } = dataState;
  const config = {
    params: {
      page: (take + skip) / take,
      size: take,
      startDtm: parseDate("yyyy-mm-dd", startDtm),
      endDtm: parseDate("yyyy-mm-dd", endDtm),
      eventType: eventType,
      userId: userId,
      elderTerm: userTerm,
      rgnCode: rgnCode,
      dongCode: dongCode,
    },
  };

  const response = await conn.get(url + "/page", config);

  return response;
};

export const setUpdateAlert = async (conn, data) => {
  const { alarmNo, elderId, callYn, visitYn, processingContent, checkDtm, checkTerm, checkId } = data;
  const params = {
    alarmNo: alarmNo,
    elderId: elderId,
    callYn: callYn,
    visitYn: visitYn,
    processingContent: processingContent,
    checkTerm: checkTerm,
    checkId: checkId,
    checkDtm: parseDate("yyyy-mm-dd hh:mm:ss", checkDtm),
  };

  const response = await conn.post(url, params);

  return response;
};

export const getEventAlarmList = async conn => {
  const response = await conn.get("/event/alarm/list");

  return response;
};

export const getAlarmNo = async (conn, userId) => {

  const config = {
    params: {
      userId: userId
    }
  }

  const response = await conn.get(url + "/no", config);

  return response;
}

// 엑셀 다운로드
export const getExcelDownload = async (param, setLoading) => {
  const excelTitle = "알림이력_" + kendo.toString(new Date(), "yyyyMMdd") + ".xlsx";
  const url = "/api/v2.2/alarm";

  // 정렬 필드 정의

  // 조건 검색 객체
  const search = {
    elderTerm: param.userTerm,
    rgnCode: param.rgnCode,
    dongCode: param.dongCode,
    startDtm: param.startDtm,
    endDtm: param.endDtm,
    eventType: param.eventType
  };

  try {
    downloadExcel(search, excelTitle, url, setLoading);
  } catch (error) {
    kendo.alert("엑셀 다운로드를 실패 하였습니다.");
    return;
  }
};
